module.exports = __webpack_public_path__ + "static/media/Biorobotics P3 Report.43e3f58c.pdf";